export const initUltimateMembers = () => {
    console.log('[consorziati] initUltimateMembers');
    const companySelect = document.querySelector('#azienda_consorziata');
    const customFieldWrapper = document.querySelector('.um-field-azienda_consorziata_altro');
    const customInput = document.querySelector('#azienda_consorziata_altro');

    if (!companySelect || !customFieldWrapper) {
        console.log('[consorziati] UM select non trovato, skip toggle', {
            hasSelect: Boolean(companySelect),
            hasWrapper: Boolean(customFieldWrapper),
        });
    } else {
        const toggleCustomField = () => {
            const isOtherSelected = companySelect.value === 'altro';
            const hasCustomValue = customInput ? customInput.value.trim() !== '' : false;

            customFieldWrapper.style.display = (isOtherSelected || hasCustomValue) ? '' : 'none';
        };

        companySelect.addEventListener('change', toggleCustomField);
        if (customInput) {
            customInput.addEventListener('input', toggleCustomField);
        }
        toggleCustomField();
    }

    const companyData = window.pannelloecologicoUmCompany || null;
    if (!companyData) {
        console.log('[consorziati] pannelloecologicoUmCompany non presente');
        return;
    }

    const isAdmin = Boolean(companyData.isAdmin);
    const editBase = companyData.adminEditBase || '/wp-admin/post.php';
    const bodyClasses = document.body ? Array.from(document.body.classList) : [];
    const isConsorziatiSingle = bodyClasses.includes('single-consorziati');
    const isConsorziatiArchive = bodyClasses.includes('post-type-archive-consorziati')
        || bodyClasses.includes('tax-categoria-consorzio')
        || bodyClasses.includes('tax-tipologia-associato');

    if (!isConsorziatiArchive && !isConsorziatiSingle) {
        console.log('[consorziati] skip edit button outside consorziati contexts');
        return;
    }

    console.log('[consorziati] dati company', {
        isAdmin,
        companyId: companyData.companyId || null,
        editUrl: companyData.editUrl || null,
        editBase,
    });
    const buildEditUrl = (postId) => {
        if (!postId) {
            return null;
        }
        if (companyData.editUrl && Number(companyData.companyId) === Number(postId)) {
            return companyData.editUrl;
        }
        return `${editBase}?post=${postId}&action=edit`;
    };

    const extractIdFromClasses = (classList, prefix) => {
        if (!classList) {
            return null;
        }
        for (const className of classList) {
            if (className.startsWith(prefix)) {
                const id = Number(className.replace(prefix, ''));
                return Number.isNaN(id) ? null : id;
            }
        }
        return null;
    };

    const createEditButton = (editUrl) => {
        if (!editUrl) {
            return null;
        }
        const link = document.createElement('a');
        link.href = editUrl;
        link.className = 'consorziati-edit-link';
        link.setAttribute('aria-label', 'Apri il backoffice dell\'azienda');
        link.setAttribute('title', 'Apri il backoffice dell\'azienda');
        link.innerHTML = `
            <span class="consorziati-edit-icon fa fa-pencil" aria-hidden="true"></span>
            <span class="consorziati-edit-text">Backoffice azienda</span>
        `;
        link.rel = 'nofollow';
        return link;
    };

    const renderArchiveEditLinks = () => {
        const archiveItems = document.querySelectorAll('.kb-query-item[class*="post-"]');
        console.log('[consorziati] archive items', archiveItems.length);
        archiveItems.forEach((archiveCard) => {
            if (archiveCard.querySelector('.consorziati-edit-link')) {
                return;
            }
            const postId = extractIdFromClasses(archiveCard.classList, 'post-');
            const editUrl = buildEditUrl(postId);
            const editButton = createEditButton(editUrl);
            if (!editButton) {
                console.log('[consorziati] skip archive item, no editUrl', { postId });
                return;
            }
            const target = archiveCard.querySelector('.consorziati-internal-link') || archiveCard;
            target.insertAdjacentElement('afterend', editButton);
        });
    };

    if (isConsorziatiArchive) {
        if (isAdmin) {
            renderArchiveEditLinks();
        } else if (companyData.editUrl && companyData.companyId) {
            const archiveCard = document.querySelector(`.kb-query-item.post-${companyData.companyId}`);
            if (archiveCard && !archiveCard.querySelector('.consorziati-edit-link')) {
                const target = archiveCard.querySelector('.consorziati-internal-link') || archiveCard;
                const editButton = createEditButton(buildEditUrl(companyData.companyId));
                if (editButton) {
                    target.insertAdjacentElement('afterend', editButton);
                }
            } else {
                console.log('[consorziati] card azienda non trovata', { companyId: companyData.companyId });
            }
        }
    }

    if (isConsorziatiSingle) {
        const singleContainer = document.querySelector('body.single-consorziati .entry-content') || document.querySelector('body.single-consorziati main');
        const singleHeading = document.querySelector('body.single-consorziati h1');
        if (singleHeading && !singleHeading.parentElement.querySelector('.consorziati-edit-link')) {
            let postId = null;
            if (document.body) {
                postId = extractIdFromClasses(document.body.classList, 'postid-');
            }
            const editUrl = isAdmin ? buildEditUrl(postId) : buildEditUrl(companyData.companyId);
            const editButton = createEditButton(editUrl);
            if (editButton) {
                editButton.classList.add('consorziati-edit-link--heading');
                singleHeading.insertAdjacentElement('afterend', editButton);
            } else {
                console.log('[consorziati] no edit button single heading', { postId, isAdmin });
            }
        }

        if (singleContainer && !singleContainer.querySelector('.consorziati-edit-link')) {
            let postId = null;
            if (document.body) {
                postId = extractIdFromClasses(document.body.classList, 'postid-');
            }
            const editUrl = isAdmin ? buildEditUrl(postId) : buildEditUrl(companyData.companyId);
            const editButton = createEditButton(editUrl);
            if (editButton) {
                singleContainer.insertAdjacentElement('afterbegin', editButton);
            } else {
                console.log('[consorziati] no edit button single', { postId, isAdmin });
            }
        } else if (!singleContainer) {
            console.log('[consorziati] container single non trovato');
        }
    }

    const runArchiveRender = () => {
        if (!isConsorziatiArchive) {
            return;
        }
        if (isAdmin) {
            renderArchiveEditLinks();
            return;
        }
        if (companyData.editUrl && companyData.companyId) {
            const archiveCard = document.querySelector(`.kb-query-item.post-${companyData.companyId}`);
            if (archiveCard && !archiveCard.querySelector('.consorziati-edit-link')) {
                const target = archiveCard.querySelector('.consorziati-internal-link') || archiveCard;
                const editButton = createEditButton(buildEditUrl(companyData.companyId));
                if (editButton) {
                    target.insertAdjacentElement('afterend', editButton);
                }
            }
        }
    };

    const observeArchiveUpdates = () => {
        let scheduled = false;
        const schedule = () => {
            if (scheduled) {
                return;
            }
            scheduled = true;
            window.requestAnimationFrame(() => {
                scheduled = false;
                runArchiveRender();
            });
        };

        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.addedNodes && mutation.addedNodes.length) {
                    schedule();
                    break;
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    };

    if (isConsorziatiArchive) {
        observeArchiveUpdates();
    }
};
